import { Box } from '@mui/material';

import { COLORS } from '@/styles/tokens/colors';

/**
 * Vertical divider between slide-editor toolbar groups. Fixed 1px × 16px in
 * GRAY[200] (not a stretching MUI `Divider`) so it stays 16px tall per the
 * Figma toolbar spec, matching `SlideToolbar`'s divider and the diagram
 * toolbar's `VerticalDivider`. Horizontal spacing comes from the toolbar row's
 * 4px gap, not a margin.
 */
export function SlideEditorToolbarDivider() {
  return <Box sx={{ width: '1px', height: 16, bgcolor: COLORS.GRAY[200] }} />;
}
